export enum Type {
  IN,
  OUT,
}

export type TypeBadgeFilledProps = {
  type: Type
}

export const TypeBadgeFilled = ({ type }: TypeBadgeFilledProps) => {
  if (type === Type.IN) {
    return (
      <svg
        width="52"
        height="24"
        viewBox="0 0 52 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="52" height="24" rx="5" fill="#579733" />
        <path
          d="M13.9999 6L17.9999 6V13.3333H20.6666L15.9999 18L11.3333 13.3333H13.9999V6Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.6278 9.18182V15H28.5739V9.18182H29.6278ZM35.5504 9.18182V15H34.6129L31.8714 11.0369H31.8232V15H30.7692V9.18182H31.7124L34.451 13.1477H34.5021V9.18182H35.5504Z"
          fill="white"
        />
      </svg>
    )
  }
  if (type == Type.OUT) {
    return (
      <svg
        width="52"
        height="24"
        viewBox="0 0 52 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="52" height="24" rx="5" fill="#E18B3B" />
        <path
          d="M18.0001 18L14.0001 18L14.0001 10.6667L11.3334 10.6667L16.0001 6L20.6667 10.6667L18.0001 10.6667L18.0001 18Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.7727 12.0909C33.7727 12.7178 33.6553 13.2547 33.4205 13.7017C33.1875 14.1468 32.8693 14.4877 32.4659 14.7244C32.0644 14.9612 31.6089 15.0795 31.0994 15.0795C30.59 15.0795 30.1335 14.9612 29.7301 14.7244C29.3286 14.4858 29.0104 14.1439 28.7756 13.6989C28.5426 13.2519 28.4261 12.7159 28.4261 12.0909C28.4261 11.464 28.5426 10.928 28.7756 10.483C29.0104 10.036 29.3286 9.69413 29.7301 9.45739C30.1335 9.22064 30.59 9.10227 31.0994 9.10227C31.6089 9.10227 32.0644 9.22064 32.4659 9.45739C32.8693 9.69413 33.1875 10.036 33.4205 10.483C33.6553 10.928 33.7727 11.464 33.7727 12.0909ZM32.7131 12.0909C32.7131 11.6496 32.6439 11.2775 32.5057 10.9744C32.3693 10.6695 32.1799 10.4394 31.9375 10.2841C31.6951 10.1269 31.4157 10.0483 31.0994 10.0483C30.7831 10.0483 30.5038 10.1269 30.2614 10.2841C30.0189 10.4394 29.8286 10.6695 29.6903 10.9744C29.554 11.2775 29.4858 11.6496 29.4858 12.0909C29.4858 12.5322 29.554 12.9053 29.6903 13.2102C29.8286 13.5133 30.0189 13.7434 30.2614 13.9006C30.5038 14.0559 30.7831 14.1335 31.0994 14.1335C31.4157 14.1335 31.6951 14.0559 31.9375 13.9006C32.1799 13.7434 32.3693 13.5133 32.5057 13.2102C32.6439 12.9053 32.7131 12.5322 32.7131 12.0909ZM38.4368 9.18182H39.4908V12.983C39.4908 13.3996 39.3923 13.7661 39.1953 14.0824C39.0002 14.3987 38.7256 14.6458 38.3714 14.8239C38.0173 15 37.6035 15.0881 37.13 15.0881C36.6546 15.0881 36.2398 15 35.8857 14.8239C35.5315 14.6458 35.2569 14.3987 35.0618 14.0824C34.8667 13.7661 34.7692 13.3996 34.7692 12.983V9.18182H35.8232V12.8949C35.8232 13.1373 35.8762 13.3532 35.9822 13.5426C36.0902 13.732 36.2417 13.8807 36.4368 13.9886C36.6319 14.0947 36.8629 14.1477 37.13 14.1477C37.397 14.1477 37.6281 14.0947 37.8232 13.9886C38.0201 13.8807 38.1716 13.732 38.2777 13.5426C38.3838 13.3532 38.4368 13.1373 38.4368 12.8949V9.18182ZM40.3807 10.0653V9.18182H45.0227V10.0653H43.2244V15H42.179V10.0653H40.3807Z"
          fill="white"
        />
      </svg>
    )
  }
}
